<template>
  <div>
    <heading size="h1" style-size="h4" class="mb-5">My Completed Work Experiences</heading>
    <vs-table ref="table" :data="completedExperiences">
      <template slot="thead">
        <vs-th sort-key="name" scope="col" width="5%">#</vs-th>
        <vs-th sort-key="name" scope="col" width="15%">Work Experience</vs-th>
        <vs-th sort-key="name" scope="col" width="10%">Type</vs-th>
        <vs-th sort-key="email" scope="col" width="15%">Date Started</vs-th>
        <vs-th sort-key="popularity" scope="col" width="15%">Date Completed</vs-th>
        <vs-th sort-key="popularity" scope="col" width="15%">Certificate Status</vs-th>
        <vs-th sort-key="popularity" scope="col" width="15%">Certificate</vs-th>
        <vs-th scope="col" width="10%">Action</vs-th>
      </template>

      <template>
        <tbody class="whitespace-no-wrap">
          <vs-tr
            :data="experience"
            :key="indextr"
            v-for="(experience, indextr) in completedExperiences"
          >
            <vs-td>{{ indextr + 1 }}</vs-td>
            <vs-td scope="row">{{ experience.vje.name }}</vs-td>
            <vs-td>
              <vs-chip color="danger" v-if="experience.type == 1">Virtual</vs-chip>
              <vs-chip color="primary" v-else>Real World</vs-chip>
            </vs-td>
            <vs-td>{{ experience.date_started_formatted }}</vs-td>
            <vs-td>{{ experience.date_completed_formatted }}</vs-td>
            <vs-td>
              <vs-chip color="dark" v-if="experience.postwork.certificate_status == 3"
                >Declined</vs-chip
              >
              <vs-chip color="primary" v-else-if="experience.postwork.certificate_status == 2"
                >Approved</vs-chip
              >
              <vs-chip color="warning" v-else-if="experience.postwork.certificate_status == 1"
                >Not Approved</vs-chip
              >
              <vs-chip color="danger" v-else>Not Requested</vs-chip>
            </vs-td>
            <vs-td>
              <button
                class="btn btn-primary btn-size-small includedIcon"
                :aria-label="`View ${experience.vje.name} experience certificate`"
                @click="
                  viewCertificate(experience.certificate_data.certificate_url, experience.vje.name)
                "
                v-if="experience.postwork.certificate_status == 2"
              >
                <download-icon />View Certificate
              </button>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <button
                class="btn btn-primary btn-size-small"
                role="link"
                :aria-label="`View ${experience.vje.name} experience`"
                @click="
                  viewExperience(
                    experience.id,
                    experience.type,
                    experience.postwork.certificate_status,
                  )
                "
              >
                View Experience
              </button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import store from '@/store/store';
import router from '@/router/router';
import { DownloadIcon } from 'vue-feather-icons';

export default {
  components: {
    DownloadIcon,
  },
  computed: {
    completedExperiences() {
      const experiences = Array.from(store.getters['authStudent/experiences']);
      let completed_experiences = [];
      experiences.forEach((experience) => {
        let copied_experience = Object.assign({}, experience);
        if (copied_experience.completed) {
          if (
            typeof copied_experience.postwork == 'undefined' ||
            copied_experience.postwork == null
          ) {
            copied_experience.postwork = {
              certificate_status: 0,
            };
          }
          completed_experiences.push(copied_experience);
        }
      });
      const makeDate = (str) => {
        /* eslint-disable no-unused-vars */
        const [_, yyyy, mm, dd, hh, min, ss] = str.match(
          /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/,
        );
        return new Date(yyyy, mm - 1, dd, hh, min, ss);
      };

      completed_experiences.sort((a, b) => makeDate(b.date_completed) - makeDate(a.date_completed));
      return completed_experiences;
    },
  },
  methods: {
    viewCertificate(url, name) {
      // Certificates live in private storage, so the url arrives already signed.
      store.dispatch('popup/showIframePopup', { src: url, title: `${name} certificate` });
    },
    viewExperience(experienceID, type, certificate_status) {
      if (type == 1) {
        if (certificate_status == 3)
          router.push('/student/work-experience/' + experienceID + '/certificate');
        else router.push('/student/work-experience/' + experienceID + '/tour_and_induction');
      } else router.push('/student/work-experience/' + experienceID + '/experience-info');
    },
  },
};
</script>
